import styled from 'styled-components';

const COLUMN_GAP = '32px';
const ROW_GAP = '24px';
const TOGGLES_GAP = '16px';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${TOGGLES_GAP};
`;

export const InputsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: ${COLUMN_GAP};
  row-gap: ${ROW_GAP};
  align-items: start;
`;

export const InputContainer = styled.div`
  min-width: 0;

  .text-input-container,
  .input-dropdown-container {
    margin-top: 0px !important;
  }
`;
